// removed by extract-text-webpack-plugin
module.exports = {"left-block":"left-block_1SdZa","right-block":"right-block_3IDoX","container":"container_3hRQq","button":"button_2UAKZ","step-1":"step-1_1tUbX","step-2":"step-2_MkwzZ","step-3":"step-3_1MkdX","step2":"step2_c3e_5","confirm":"confirm_2hNEQ","full":"full_2wQmH"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/container/classFixed/style.css
 ** module id = 942
 ** module chunks = 0
 **/